import { ResourceBasePath } from '@sh4res/bo-common/hooks';
import { Resources } from '@sh4res/bo-common/utils';

export const getB2BInvestorProfileResourceReference = (
  resourceBasePath: ResourceBasePath,
): Resources => `${resourceBasePath}investor_profile`;
